import './App.css';
import RoutesData from './services/RoutesData';

function App() {
  return (
    <RoutesData/>
  );
}

export default App;
